import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, Swords } from "lucide-react";
import { useLang } from "@/i18n";

export const Navbar = () => {
  const { lang, setLang, t } = useLang();
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const links = [
    { to: "/articles", label: t("nav_articles") },
    { to: "/reviews", label: t("nav_reviews") },
    { to: "/blueprint", label: t("nav_blueprint") },
    { to: "/newsletter", label: t("nav_newsletter") },
    { to: "/waitlist", label: t("nav_waitlist") },
  ];

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#0c0d10]/85 border-b border-[#272b35]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2 group">
          <span className="w-9 h-9 grid place-items-center bg-[#E63946] rounded-sm">
            <Swords size={20} className="text-white" />
          </span>
          <span className="font-heading text-2xl font-black uppercase tracking-tight text-white leading-none">
            Guardia<span className="text-[#E63946]">.</span>
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.slice(1)}`}
              className="text-sm font-semibold text-zinc-300 hover:text-white transition-colors"
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <div className="flex items-center bg-[#14161b] border border-[#272b35] rounded-full p-0.5">
            {["it", "en"].map((lc) => (
              <button
                key={lc}
                data-testid={`lang-switch-${lc}`}
                onClick={() => setLang(lc)}
                className={`px-3 py-1 text-xs font-mono uppercase rounded-full transition-colors ${
                  lang === lc ? "bg-[#E63946] text-white" : "text-zinc-400"
                }`}
              >
                {lc}
              </button>
            ))}
          </div>
          <button
            data-testid="nav-cta-blueprint"
            onClick={() => navigate("/blueprint")}
            className="hidden sm:inline-flex px-4 py-2 bg-[#E63946] hover:bg-[#D90429] text-white text-sm font-bold uppercase tracking-wide rounded-md transition-colors"
          >
            {t("cta_blueprint")}
          </button>
          <button className="lg:hidden text-white" data-testid="mobile-menu-toggle" onClick={() => setOpen(!open)}>
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#272b35] bg-[#0c0d10] px-4 py-4 space-y-3">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.to.slice(1)}`}
              onClick={() => setOpen(false)}
              className="block text-base font-semibold text-zinc-200"
            >
              {l.label}
            </Link>
          ))}
          <Link to="/login" onClick={() => setOpen(false)} className="block text-sm text-zinc-500">
            {t("nav_login")}
          </Link>
        </div>
      )}
    </header>
  );
};
